import { client } from '@api/client';
import { URL } from '@api/urls';

import { IItemsResponse } from '@interfaces/common/response';
import { IAssetRentRequest } from '@interfaces/rent/assetRent';
import { IAssetProfileOutgoingRequestsDTO } from '@interfaces/rent/dto/assetRequestsDTO';

const {
	assetProfileOutgoingRequests,
} = URL;

export const getAssetProfileOutgoingRequests = (
	params: IAssetProfileOutgoingRequestsDTO,
): Promise<IItemsResponse<IAssetRentRequest>> => {
	return client.get(assetProfileOutgoingRequests, {
		params,
	});
};
